
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 11.093 12.226"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 7118","d":"M9.436 1.905A5.931 5.931 0 005.065 0 6 6 0 00.594 2.015a2.458 2.458 0 00-.142 3.024 4.736 4.736 0 001.1 1.071c.844.652 1.51 1.166.854 2.94l-.008.02a2.247 2.247 0 00.144 1.967 2.28 2.28 0 001.653 1.128 6.01 6.01 0 00.866.063q.232 0 .465-.018a6.137 6.137 0 003.905-10.3zm-2.42.56a1.137 1.137 0 110 1.608 1.137 1.137 0 010-1.607zM2.938 4.074a1.134 1.134 0 11.335-.8 1.137 1.137 0 01-.335.8zm2.039 7.3a1.137 1.137 0 111.137-1.137 1.137 1.137 0 01-1.137 1.137zm0-8.246A1.137 1.137 0 116.114 1.99a1.137 1.137 0 01-1.137 1.138zm3.648 6.633a1.134 1.134 0 11.335-.8 1.137 1.137 0 01-.336.8zm.475-2.51a1.137 1.137 0 111.137-1.137A1.137 1.137 0 019.1 7.25z","fill":"#7ac774"}})])
          )
        }
      }
    